// extracted by mini-css-extract-plugin
export default {"action-container":"UnclaimedRowChild_action-container__dF8Vr","claim-btn":"UnclaimedRowChild_claim-btn__6FYkE"};